import { Link } from "react-router-dom";
import "./mernstack.css";

const MernStack = () => {

  const modules = [

    {
      no: "01",
      title: "Web Development Fundamentals",
      icon: "🌐",
      topics: [
        "Introduction to Web Development",
        "Client-Server Architecture",
        "Internet & Web",
        "HTTP & HTTPS",
        "Frontend vs Backend",
        "HTML5",
        "Semantic HTML",
        "Forms & Validation",
        "Tables, Lists & Multimedia",
        "CSS3",
        "Selectors & Box Model",
        "Flexbox",
        "CSS Grid",
        "Responsive Web Design",
        "Media Queries",
        "CSS Animations & Transitions"
      ],
    },

    {
      no: "02",
      title: "JavaScript Fundamentals",
      icon: "🟨",
      topics: [
        "Introduction to JavaScript",
        "Variables",
        "Data Types",
        "Operators",
        "Conditional Statements",
        "Loops",
        "Functions",
        "Arrow Functions",
        "Arrays",
        "Objects",
        "Strings",
        "Template Literals",
        "Destructuring",
        "Spread Operator",
        "Rest Operator",
        "Array Methods",
        "JSON",
        "ES6+ Features"
      ],
    },

    {
      no: "03",
      title: "Advanced JavaScript",
      icon: "⚡",
      topics: [
        "DOM Manipulation",
        "Event Handling",
        "Event Bubbling",
        "Event Capturing",
        "Callbacks",
        "Higher Order Functions",
        "Map",
        "Filter",
        "Reduce",
        "Find",
        "Some & Every",
        "Promises",
        "Async/Await",
        "Fetch API",
        "Error Handling",
        "Closures",
        "Hoisting",
        "Scope",
        "Modules"
      ],
    },

    {
      no: "04",
      title: "React JS Fundamentals",
      icon: "⚛️",
      topics: [
        "Introduction to React",
        "React Architecture",
        "SPA",
        "Vite",
        "Project Setup",
        "Components",
        "Functional Components",
        "JSX",
        "Props",
        "State",
        "Events",
        "Conditional Rendering",
        "Lists & Keys",
        "Component Reusability",
        "Forms",
        "Controlled Components",
        "Form Validation"
      ],
    },

    {
      no: "05",
      title: "React Hooks",
      icon: "🪝",
      topics: [
        "Introduction to Hooks",
        "useState",
        "useEffect",
        "useContext",
        "useRef",
        "useMemo",
        "useCallback",
        "Custom Hooks",
        "Rules of Hooks",
        "State Management",
        "Side Effects",
        "API Calls using Hooks",
        "Component Lifecycle"
      ],
    },

    {
      no: "06",
      title: "React Router & Navigation",
      icon: "🧭",
      topics: [
        "React Router",
        "BrowserRouter",
        "Routes",
        "Route",
        "Link",
        "NavLink",
        "useNavigate",
        "useParams",
        "useLocation",
        "Nested Routes",
        "Dynamic Routes",
        "Protected Routes",
        "404 Page",
        "Navigation Management"
      ],
    },

    {
      no: "07",
      title: "React API Integration",
      icon: "🔄",
      topics: [
        "REST API Concepts",
        "HTTP Methods",
        "GET API",
        "POST API",
        "PUT API",
        "PATCH API",
        "DELETE API",
        "Axios",
        "Fetch API",
        "Request Configuration",
        "Response Handling",
        "Error Handling",
        "Loading States",
        "API Data Rendering",
        "CORS"
      ],
    },

    {
      no: "08",
      title: "Advanced React & Redux",
      icon: "🧩",
      topics: [
        "Context API",
        "Global State Management",
        "Redux Introduction",
        "Redux Architecture",
        "Redux Toolkit",
        "Store",
        "Slice",
        "Actions",
        "Reducers",
        "Selectors",
        "useSelector",
        "useDispatch",
        "Async Operations",
        "createAsyncThunk",
        "State Persistence"
      ],
    },

    {
      no: "09",
      title: "Node.js Fundamentals",
      icon: "🟢",
      topics: [
        "Introduction to Node.js",
        "Node.js Architecture",
        "Installation",
        "Node Runtime",
        "NPM",
        "package.json",
        "Modules",
        "CommonJS",
        "ES Modules",
        "File System",
        "Path Module",
        "Events",
        "Event Emitter",
        "Streams",
        "Buffers",
        "Environment Variables"
      ],
    },

    {
      no: "10",
      title: "Express.js",
      icon: "🚂",
      topics: [
        "Introduction to Express.js",
        "Express Server",
        "Application Setup",
        "Routing",
        "Route Parameters",
        "Query Parameters",
        "Request Object",
        "Response Object",
        "Middleware",
        "Custom Middleware",
        "Error Handling Middleware",
        "Controllers",
        "Services",
        "REST API Development",
        "CORS",
        "Environment Configuration"
      ],
    },

    {
      no: "11",
      title: "MongoDB",
      icon: "🍃",
      topics: [
        "Introduction to MongoDB",
        "NoSQL Database",
        "MongoDB Architecture",
        "Database",
        "Collections",
        "Documents",
        "Fields",
        "MongoDB Compass",
        "MongoDB Shell",
        "CRUD Operations",
        "Insert Documents",
        "Find Documents",
        "Update Documents",
        "Delete Documents",
        "Query Operators",
        "Sorting",
        "Indexes",
        "Aggregation"
      ],
    },

    {
      no: "12",
      title: "Mongoose",
      icon: "🗄️",
      topics: [
        "Introduction to Mongoose",
        "MongoDB Connection",
        "Schema",
        "Model",
        "CRUD Operations",
        "Schema Validation",
        "Default Values",
        "Custom Validation",
        "Middleware",
        "References",
        "Population",
        "Embedded Documents",
        "Indexes",
        "Query Methods",
        "Aggregation"
      ],
    },

    {
      no: "13",
      title: "REST API Development",
      icon: "🔌",
      topics: [
        "REST Architecture",
        "REST Principles",
        "API Design",
        "HTTP Methods",
        "HTTP Status Codes",
        "Request Headers",
        "Response Headers",
        "JSON",
        "CRUD REST API",
        "Controller Structure",
        "Service Structure",
        "Validation",
        "Error Handling",
        "API Testing",
        "Postman"
      ],
    },

    {
      no: "14",
      title: "Authentication & Authorization",
      icon: "🔐",
      topics: [
        "Authentication Concepts",
        "Authorization Concepts",
        "User Registration",
        "User Login",
        "Password Hashing",
        "bcrypt",
        "JWT",
        "JWT Structure",
        "Access Token",
        "Refresh Token",
        "Token Validation",
        "Protected Routes",
        "Role Based Authorization",
        "Admin Authentication",
        "User Authentication",
        "Logout"
      ],
    },

    {
      no: "15",
      title: "File Upload & Image Management",
      icon: "📁",
      topics: [
        "File Upload Concepts",
        "Multipart Form Data",
        "Multer",
        "Single File Upload",
        "Multiple File Upload",
        "Image Validation",
        "File Size Validation",
        "File Storage",
        "Static Files",
        "Image Management",
        "Cloud Storage",
        "Cloudinary Integration"
      ],
    },

    {
      no: "16",
      title: "Full Stack Integration",
      icon: "🔗",
      topics: [
        "React + Node.js Integration",
        "React + Express Integration",
        "Frontend Backend Communication",
        "REST API Integration",
        "Axios Configuration",
        "API Services",
        "CORS Configuration",
        "Authentication Integration",
        "JWT Integration",
        "Protected Frontend Routes",
        "Role Based Access",
        "Error Handling",
        "Loading States",
        "Environment Variables"
      ],
    },

    {
      no: "17",
      title: "Advanced Node.js & Express",
      icon: "🚀",
      topics: [
        "Advanced Middleware",
        "Authentication Middleware",
        "Authorization Middleware",
        "Error Handling",
        "Async Error Handling",
        "API Security",
        "Rate Limiting",
        "Input Validation",
        "Security Headers",
        "Environment Configuration",
        "Logging",
        "Performance Optimization",
        "Clean Architecture"
      ],
    },

    {
      no: "18",
      title: "Advanced MongoDB",
      icon: "📊",
      topics: [
        "MongoDB Indexing",
        "Compound Indexes",
        "Aggregation Framework",
        "Aggregation Pipeline",
        "Match",
        "Group",
        "Sort",
        "Lookup",
        "Unwind",
        "Pagination",
        "Searching",
        "Filtering",
        "Transactions",
        "Database Optimization"
      ],
    },

    {
      no: "19",
      title: "Testing & Debugging",
      icon: "🧪",
      topics: [
        "Software Testing Basics",
        "API Testing",
        "Postman",
        "Request Testing",
        "Response Validation",
        "HTTP Status Codes",
        "Debugging",
        "Chrome DevTools",
        "React DevTools",
        "Node.js Debugging",
        "Error Handling",
        "Logging",
        "Authentication Testing"
      ],
    },

    {
      no: "20",
      title: "Git & GitHub",
      icon: "🐙",
      topics: [
        "Git Introduction",
        "Git Installation",
        "Repository",
        "git init",
        "git clone",
        "git add",
        "git commit",
        "git status",
        "git log",
        "Branch",
        "Merge",
        "Pull",
        "Push",
        "GitHub",
        "Pull Request",
        ".gitignore",
        "Repository Management"
      ],
    },

    {
      no: "21",
      title: "Deployment & Production",
      icon: "☁️",
      topics: [
        "Production Build",
        "Environment Variables",
        "Frontend Deployment",
        "Backend Deployment",
        "MongoDB Atlas",
        "Cloud Deployment",
        "Hosting",
        "Domain Configuration",
        "Production Configuration",
        "Application Monitoring",
        "Basic CI/CD Concepts"
      ],
    },

    {
      no: "22",
      title: "DSA with JavaScript",
      icon: "🧠",
      topics: [
        "Time Complexity",
        "Space Complexity",
        "Arrays",
        "Strings",
        "Searching",
        "Linear Search",
        "Binary Search",
        "Sorting",
        "Bubble Sort",
        "Selection Sort",
        "Insertion Sort",
        "Merge Sort",
        "Quick Sort",
        "Stack",
        "Queue",
        "Linked List",
        "Hashing",
        "Recursion",
        "Trees",
        "Graphs"
      ],
    },

    {
      no: "23",
      title: "MERN Stack Projects",
      icon: "💼",
      topics: [
        "E-Commerce Application",
        "CRM Application",
        "HRMS Application",
        "Employee Management System",
        "User Registration",
        "Login & Authentication",
        "JWT Authentication",
        "Role Based Access",
        "Admin Dashboard",
        "User Dashboard",
        "CRUD Operations",
        "REST API",
        "MongoDB Database",
        "React Frontend",
        "Node.js Backend",
        "Express.js API",
        "Project Deployment"
      ],
    },

    {
      no: "24",
      title: "Interview & Placement Preparation",
      icon: "🎯",
      topics: [
        "HTML Interview Questions",
        "CSS Interview Questions",
        "JavaScript Interview Questions",
        "React Interview Questions",
        "Node.js Interview Questions",
        "Express.js Interview Questions",
        "MongoDB Interview Questions",
        "REST API Questions",
        "JWT Questions",
        "Redux Questions",
        "DSA Coding Problems",
        "Project Explanation",
        "Resume Preparation",
        "GitHub Profile Preparation",
        "Mock Interviews"
      ],
    }

  ];


  return (

    <div className="mern-page">


      {/* ================= HERO ================= */}

      <section className="mern-hero">

        <div className="mern-hero-content">

          <span>
            JOB-ORIENTED TRAINING PROGRAM
          </span>

          <h1>
            MERN Stack
            <strong>Development</strong>
          </h1>

          <p>
            Learn complete full stack development from
            HTML, CSS and JavaScript to React, Node.js,
            Express.js, MongoDB, REST APIs, JWT,
            DSA and real-world projects.
          </p>

          <div className="mern-hero-buttons">

            <a href="#mern-syllabus">
              View Complete Syllabus
            </a>

            <Link to="/contact">
              Enquire Now
            </Link>

          </div>

        </div>

      </section>


      {/* ================= COURSE OVERVIEW ================= */}

      <section className="mern-overview">

        <div className="overview-card">
          <strong>24+</strong>
          <span>Learning Modules</span>
        </div>

        <div className="overview-card">
          <strong>10+</strong>
          <span>Technologies</span>
        </div>

        <div className="overview-card">
          <strong>3+</strong>
          <span>Major Projects</span>
        </div>

        <div className="overview-card">
          <strong>100%</strong>
          <span>Practical Training</span>
        </div>

      </section>


      {/* ================= SYLLABUS ================= */}

      <section
        id="mern-syllabus"
        className="mern-syllabus"
      >

        <div className="syllabus-heading">

          <span>
            COURSE CURRICULUM
          </span>

          <h2>
            Complete MERN Stack Syllabus
          </h2>

          <p>
            A structured learning path covering frontend,
            backend, database, authentication, deployment,
            DSA and real-world full stack development.
          </p>

        </div>


        <div className="mern-module-grid">

          {modules.map((module) => (

            <article
              className="mern-module-card"
              key={module.no}
            >

              <div className="module-top">

                <span className="module-number">
                  {module.no}
                </span>

                <span className="module-icon">
                  {module.icon}
                </span>

              </div>

              <h3>
                {module.title}
              </h3>

              <ul>

                {module.topics.map((topic) => (

                  <li key={topic}>

                    <span>✓</span>

                    {topic}

                  </li>

                ))}

              </ul>

            </article>

          ))}

        </div>

      </section>


      {/* ================= TECHNOLOGY STACK ================= */}

      <section className="technology-section">

        <div className="syllabus-heading">

          <span>
            TECHNOLOGY STACK
          </span>

          <h2>
            Technologies You Will Learn
          </h2>

        </div>

        <div className="technology-grid">

          <div>⚛️ React JS</div>

          <div>🟢 Node.js</div>

          <div>🚂 Express.js</div>

          <div>🍃 MongoDB</div>

          <div>🟨 JavaScript</div>

          <div>🔐 JWT</div>

          <div>🔄 Redux Toolkit</div>

          <div>🐙 Git & GitHub</div>

          <div>📮 Postman</div>

          <div>☁️ MongoDB Atlas</div>

        </div>

      </section>


      {/* ================= PROJECTS ================= */}

      <section className="mern-projects">

        <div className="syllabus-heading">

          <span>
            REAL WORLD DEVELOPMENT
          </span>

          <h2>
            Projects You Will Build
          </h2>

        </div>


        <div className="project-training-grid">

          <article>

            <span>
              PROJECT 01
            </span>

            <h3>
              E-Commerce Application
            </h3>

            <p>
              Complete e-commerce application with
              product management, shopping cart,
              authentication, orders and admin dashboard.
            </p>

          </article>


          <article>

            <span>
              PROJECT 02
            </span>

            <h3>
              CRM Application
            </h3>

            <p>
              Customer relationship management system
              with leads, customers, dashboards,
              authentication and role-based access.
            </p>

          </article>


          <article>

            <span>
              PROJECT 03
            </span>

            <h3>
              HRMS Application
            </h3>

            <p>
              Employee management system with employee
              CRUD, authentication, roles, dashboards
              and database integration.
            </p>

          </article>

        </div>

      </section>


      {/* ================= ENQUIRY ================= */}

      <section
        id="mern-enquiry"
        className="mern-enquiry"
      >

        <div>

          <span>
            START YOUR JOURNEY
          </span>

          <h2>
            Become a MERN Stack Developer
          </h2>

          <p>
            Learn industry-relevant technologies and build
            real-world full stack applications with practical
            project-based training.
          </p>

        </div>

        <Link to="/contact">
          Enquire Now →
        </Link>

      </section>


    </div>

  );

};

export default MernStack;